module.exports = __webpack_public_path__ + "img/projectLayerMobile.52786ab0.svg";